type SortByOrderItem = { order: number } & unknown;

export const sortByOrder = (item: SortByOrderItem, comparisonItem: SortByOrderItem): number => (
    item.order - comparisonItem.order
);

export const sortWithPriority = <Type, Key extends string>(
    array: Type[],
    attr: keyof Type,
    priorityKeys: Key[],
): Type[] => {
    const getPriorityIndex = (key: Key): number => {
        const index = priorityKeys.indexOf(key);
        return index === -1 ? Infinity : index;
    };

    return array.sort((filter, comparisonFilter): number => {
        const attribute = filter[attr] as Key;
        const comparisonAttribute = comparisonFilter[attr] as Key;

        const priority = getPriorityIndex(attribute);
        const comparisonPriority = getPriorityIndex(comparisonAttribute);

        return priority !== comparisonPriority
            ? priority - comparisonPriority
            : attribute.localeCompare(comparisonAttribute);
    });
};
